import React from "react"

const Setting = () => {
    return (
        <div>
            <h2>설정</h2>
            <p>사용자 계정 및 앱 설정을 변경합니다.</p>
        </div>
    );
};

export default Setting;
